<perfect-scrollbar class="side-nav" sideNav>
    <!-- -arabic- ant-menu-rtl : styles droite-a-gauche de ng-zorro (ce menu n'est pas un composant nz-menu) -->
    <ul class="ant-menu ant-menu-root ant-menu-inline side-nav-menu" [class.ant-menu-rtl]="rtl"
        [ngClass]="{
            'ant-menu-inline-collapsed': isFolded,
            'ant-menu-dark' : isSideNavDark
        }"
    >
    <li class="text-center py-4" [ngClass]="{ 'd-none': isFolded }">
        <nz-avatar [nzIcon]="'user'" 
                     [nzSrc]="user?.imagePath ? 'assets/images/avatars/' + user.imagePath : null"
 style="width: 80px; height: 80px;"
                    
                    
                    ></nz-avatar>
        
        <div class="mt-3">
          <strong class="d-block">{{ user.lastname }} {{ user.firstname }}</strong>
          <!-- -sidebar- une ligne par paire : "établissement / rôle" -->
          <div *ngIf="pairs.length" class="mt-1">
            <small *ngIf="techRoles.length" class="text-muted d-block font-size-12">{{ techRoles.join(', ') }}</small>
            <small *ngFor="let p of pairs" class="text-muted d-block font-size-12">
              {{ p.etablissementId === 0 ? ('common.other' | translate) : p.etablissementNom }}<span *ngIf="p.roleName"> / {{ p.roleName | roleLabel }}</span>
            </small>
          </div>
          <ng-container *ngIf="!pairs.length">
          <small class="text-muted d-block mt-1 font-size-12">
            <ng-container *ngFor="let role of user?.roles; let isLast = last">
              {{ role.name | roleLabel }}<span *ngIf="!isLast">, </span>
            </ng-container>
          </small>
            <small class="text-muted d-block mt-1 font-size-12">
            <ng-container *ngFor="let role of user?.rolesClient; let isLast = last">
              {{ role.name | roleLabel }}<span *ngIf="!isLast">, </span>
            </ng-container>
          </small>

          <span class="text-muted d-block mt-1 font-size-12">
            <ul>
                

  <li *ngFor="let etab of user?.etablissements || []">
    {{ etab.nom }}
  </li>
</ul></span>
          </ng-container>
        </div>
      </li>
      
      
        <li [ngClass]="item.submenu.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline' : 'ant-menu-item'"
            *ngFor="let item of menuItems" 
            [routerLinkActive]="item.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
            [routerLinkActiveOptions]="{exact: true}">
            <a href="javascript:void(0);" class="ant-menu-submenu-title" 
               *ngIf="item.submenu.length > 0" (click)="navigate(item)">
                <i *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" [theme]="item.iconTheme"></i>
                <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme, item.icon]"></i>
                <span>{{ item.title | translate }}</span>
                <i class="ant-menu-submenu-arrow"></i>
            </a>
            <a *ngIf="item.submenu.length === 0" class="ant-menu-submenu-title" 
               (click)="navigate(item)">
                <i *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" [theme]="item.iconTheme"></i>
                <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme, item.icon]"></i>
                <span>{{ item.title | translate }}</span>
            </a>

            <!-- Second Level -->
            <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu" [class.ant-menu-rtl]="rtl"
                *ngIf="item.submenu.length > 0">
                <li [ngClass]="subItem.submenu.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline' : 'ant-menu-item'" 
                    *ngFor="let subItem of item.submenu" 
                    [routerLinkActive]="subItem.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
                    [routerLinkActiveOptions]="{exact: true}">
                    <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-50" 
                       *ngIf="subItem.submenu.length > 0" (click)="navigate(subItem)">
                        <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon" [theme]="subItem.iconTheme"></i>
                        <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme, subItem.icon]"></i>
                        <span>{{ subItem.title | translate }}</span>
                        <i class="ant-menu-submenu-arrow"></i>
                    </a>
                    <a *ngIf="subItem.submenu.length === 0" class="ant-menu-submenu-title" 
                       (click)="navigate(subItem)" class="p-l-30">
                        <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon" [theme]="subItem.iconTheme"></i>
                        <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme, subItem.icon]"></i>
                        <span>{{ subItem.title | translate }}</span>
                    </a>

                    <!-- Third Level -->
                    <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu" [class.ant-menu-rtl]="rtl"
                        *ngIf="subItem.submenu.length > 0">
                        <li [ngClass]="subItem.submenu.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline' : 'ant-menu-item'" 
                            *ngFor="let subItem of subItem.submenu" 
                            routerLinkActive="ant-menu-item-selected" 
                            [routerLinkActiveOptions]="{exact: true}">
                            <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-50" 
                               *ngIf="subItem.submenu.length > 0" (click)="navigate(subItem)">
                                <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon" [theme]="subItem.iconTheme"></i>
                                <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme, subItem.icon]"></i>
                                <span>{{ subItem.title | translate }}</span>
                                <i class="ant-menu-submenu-arrow"></i>
                            </a>
                            <a *ngIf="subItem.submenu.length === 0" class="ant-menu-submenu-title" 
                               (click)="navigate(subItem)" class="p-l-50">
                                <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon" [theme]="subItem.iconTheme"></i>
                                <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme, subItem.icon]"></i>
                                <span>{{ subItem.title | translate }}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</perfect-scrollbar>
